import { useContext } from 'react';

import { Lang } from 'context';

const useLang = () => useContext(Lang.Context);

export default useLang;
